export type AfricanCountry = {
  name: string
  iso2: string
  flag: string
}

function isoToFlag(iso2: string): string {
  return iso2
    .toUpperCase()
    .replace(/./g, (char) =>
      String.fromCodePoint(char.charCodeAt(0) + 127397)
    );
}

export const AFRICAN_COUNTRIES: AfricanCountry[] = [
  { iso2: 'DZ', name: 'Algeria', flag: isoToFlag('DZ') },
  { iso2: 'AO', name: 'Angola', flag: isoToFlag('AO') },
  { iso2: 'BJ', name: 'Benin', flag: isoToFlag('BJ') },
  { iso2: 'BW', name: 'Botswana', flag: isoToFlag('BW') },
  { iso2: 'BF', name: 'Burkina Faso', flag: isoToFlag('BF') },
  { iso2: 'BI', name: 'Burundi', flag: isoToFlag('BI') },
  { iso2: 'CM', name: 'Cameroon', flag: isoToFlag('CM') },
  { iso2: 'CV', name: 'Cape Verde', flag: isoToFlag('CV') },
  { iso2: 'CF', name: 'Central African Republic', flag: isoToFlag('CF') },
  { iso2: 'TD', name: 'Chad', flag: isoToFlag('TD') },
  { iso2: 'KM', name: 'Comoros', flag: isoToFlag('KM') },
  { iso2: 'CG', name: 'Congo', flag: isoToFlag('CG') },
  { iso2: 'CD', name: 'DR Congo', flag: isoToFlag('CD') },
  { iso2: 'CI', name: "Côte d'Ivoire", flag: isoToFlag('CI') },
  { iso2: 'DJ', name: 'Djibouti', flag: isoToFlag('DJ') },
  { iso2: 'EG', name: 'Egypt', flag: isoToFlag('EG') },
  { iso2: 'GQ', name: 'Equatorial Guinea', flag: isoToFlag('GQ') },
  { iso2: 'ER', name: 'Eritrea', flag: isoToFlag('ER') },
  { iso2: 'SZ', name: 'Eswatini', flag: isoToFlag('SZ') },
  { iso2: 'ET', name: 'Ethiopia', flag: isoToFlag('ET') },
  { iso2: 'GA', name: 'Gabon', flag: isoToFlag('GA') },
  { iso2: 'GM', name: 'Gambia', flag: isoToFlag('GM') },
  { iso2: 'GH', name: 'Ghana', flag: isoToFlag('GH') },
  { iso2: 'GN', name: 'Guinea', flag: isoToFlag('GN') },
  { iso2: 'GW', name: 'Guinea-Bissau', flag: isoToFlag('GW') },
  { iso2: 'KE', name: 'Kenya', flag: isoToFlag('KE') },
  { iso2: 'LS', name: 'Lesotho', flag: isoToFlag('LS') },
  { iso2: 'LR', name: 'Liberia', flag: isoToFlag('LR') },
  { iso2: 'LY', name: 'Libya', flag: isoToFlag('LY') },
  { iso2: 'MG', name: 'Madagascar', flag: isoToFlag('MG') },
  { iso2: 'MW', name: 'Malawi', flag: isoToFlag('MW') },
  { iso2: 'ML', name: 'Mali', flag: isoToFlag('ML') },
  { iso2: 'MR', name: 'Mauritania', flag: isoToFlag('MR') },
  { iso2: 'MU', name: 'Mauritius', flag: isoToFlag('MU') },
  { iso2: 'MA', name: 'Morocco', flag: isoToFlag('MA') },
  { iso2: 'MZ', name: 'Mozambique', flag: isoToFlag('MZ') },
  { iso2: 'NA', name: 'Namibia', flag: isoToFlag('NA') },
  { iso2: 'NE', name: 'Niger', flag: isoToFlag('NE') },
  { iso2: 'NG', name: 'Nigeria', flag: isoToFlag('NG') },
  { iso2: 'RW', name: 'Rwanda', flag: isoToFlag('RW') },
  { iso2: 'ST', name: 'São Tomé and Príncipe', flag: isoToFlag('ST') },
  { iso2: 'SN', name: 'Senegal', flag: isoToFlag('SN') },
  { iso2: 'SC', name: 'Seychelles', flag: isoToFlag('SC') },
  { iso2: 'SL', name: 'Sierra Leone', flag: isoToFlag('SL') },
  { iso2: 'SO', name: 'Somalia', flag: isoToFlag('SO') },
  { iso2: 'ZA', name: 'South Africa', flag: isoToFlag('ZA') },
  { iso2: 'SS', name: 'South Sudan', flag: isoToFlag('SS') },
  { iso2: 'SD', name: 'Sudan', flag: isoToFlag('SD') },
  { iso2: 'TZ', name: 'Tanzania', flag: isoToFlag('TZ') },
  { iso2: 'TG', name: 'Togo', flag: isoToFlag('TG') },
  { iso2: 'TN', name: 'Tunisia', flag: isoToFlag('TN') },
  { iso2: 'UG', name: 'Uganda', flag: isoToFlag('UG') },
  { iso2: 'ZM', name: 'Zambia', flag: isoToFlag('ZM') },
  { iso2: 'ZW', name: 'Zimbabwe', flag: isoToFlag('ZW') },
]

export function countryToFlag(iso2: string): string {
  if (!iso2 || iso2.length !== 2) return '🌍'
  const country = AFRICAN_COUNTRIES.find(
    (c) => c.iso2 === iso2.toUpperCase()
  )
  return country?.flag ?? isoToFlag(iso2)
}
